export const clearSecretIndication = (secretValue?: string | boolean) =>
  typeof secretValue === 'boolean' ? undefined : secretValue;

export const clearOptionalSecret = (secretValue?: string | boolean) =>
  clearSecretIndication(secretValue) || undefined;
